import turnkeyImg from "../../../assets/images/service/turnekeyproject.png";
import {
  Settings,
  Zap,
  FileCheck,
  ShieldCheck,
  Clock,
  HardHat,
  TrendingUp,
  Maximize,
  UserCheck,
  Factory,
  Flame
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function TurnkeyProjects() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Turnkey Solutions for <span className="green">EVCS, CBG & CNG</span>
                  </h2>
                  <h5 className="text-muted mb-3">From Concept to Commissioning</h5>
                  <p className="mb-4">
                    Denial Enterprise delivers end-to-end turnkey infrastructure for the new energy economy. 
                    We manage the complex convergence of high-voltage electricals, mechanical engineering, 
                    and gas compression systems.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Integrated Design, Procurement & Construction (EPC)</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>High-capacity DC Fast Charging & Bio-Gas processing</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Strict adherence to PESO, CEIG & PNGRB standards</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={turnkeyImg}
                      alt="Turnkey EVCS, CBG and CNG Deployment"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-leaf"></i> Zero-Emission Ready
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">Comprehensive Project Management</h3>
                    <p className="mb-3">
                      Developing EV charging hubs or Compressed Bio-Gas (CBG) plants requires a multidisciplinary approach. Denial Enterprise serves as your single point of accountability, managing the "Power to Plate" or "Waste to Fuel" journey. We eliminate the risk of vendor fragmentation by handling civil plinths, HT/LT electricals, and gas storage systems simultaneously.
                    </p>
                    <p className="mb-3">
                      Whether you are deploying a highway EV charging plaza or an industrial CNG station, our turnkey model ensures that all components—from the 66kV substation to the high-pressure gas dispensers—work in perfect harmony.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Zap size={22} />
                        </span>
                        <span>Multi-Megawatt Electrical Infrastructure Setup</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Factory size={22} />
                        </span>
                        <span>CBG Digester & CNG Compressor Installation</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Flame size={22} />
                        </span>
                        <span>Safety-Critical Gas Piping & Storage Solutions</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Regulatory Liaisoning & Final Commissioning</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">The Turnkey Advantage</h4>
                    <p className="mb-6">
                      By integrating electrical and gas expertise, we provide a unified infrastructure path that reduces project lead times by up to 30%.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Unified safety and quality control protocols</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Clock size={22} />
                        </span>
                        <span>Accelerated time-to-market for fuel retail outlets</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>Seamless hardware-software (CMS/ERP) integration</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Optimized lifecycle costs and operational reliability</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Future-proof engineering for capacity expansion</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Single-window liaison for all statutory approvals</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}